export default __webpack_public_path__ + "static/media/GuidingSouls5.353711bf.png";